import { cancelSpotAllOrders, CancelSpotOrdersBody } from 'api/v1/spot'
import toastify from 'components/Toastify'
import { memo } from 'react'
import { useAppDispatch } from 'store'
import { useAccountInfo } from 'store/account/hooks'
import { useModal } from 'store/app/hooks'
import { useHideOtherPairs } from 'store/orderbook/hooks'
import { updateCancelAllSpotAction } from 'store/spot/actions'
import { useCurrentSpotSymbol } from 'store/spot/hooks'
import { updateModal } from 'store/app/actions/modalActions'
import { getSpotOpenOrdersAction } from 'store/spot/actions/getSpotOpenOrdersActions'
import { CancelModal } from 'components/CancelModal'
import { CancelAllType } from '../../../components/CancelModal/store'

export const SpotCancelModal = memo(() => {
  const dispatch = useAppDispatch()
  const cancelModal = useModal('cancel')
  const hideOtherPairs = useHideOtherPairs()
  const { accountId = 0 } = useAccountInfo()
  const { name } = useCurrentSpotSymbol()

  return (
    <CancelModal
      visible={cancelModal}
      onClose={() => {
        dispatch(updateModal({ modal: 'cancel', open: false }))
      }}
      onOk={async (type: CancelAllType) => {
        dispatch(updateCancelAllSpotAction(true))
        try {
          const body: CancelSpotOrdersBody = {}

          if (hideOtherPairs) {
            body.symbol = name
          }
          if (type === 'LIMIT' || type === 'STOP') {
            body.type = type
          }
          const _res = await cancelSpotAllOrders(accountId, body)
          if (_res.code === 200) {
            toastify.success('Cancel successfully')
            dispatch(getSpotOpenOrdersAction(accountId))
          } else {
            toastify.error(_res.msg)
          }
        } catch (error) {
          if (error instanceof Error) {
            toastify.error(error.message)
          } else {
            toastify.error(error?.response?.data?.message)
          }
        } finally {
          dispatch(updateCancelAllSpotAction(false))
        }
      }}
    />
  )
})
